import _nativeCreate_default from "./_nativeCreate.js";

//#region ../../node_modules/lodash-es/_hashGet.js
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
* Gets the hash value for `key`.
*
* @private
* @name get
* @memberOf Hash
* @param {string} key The key of the value to get.
* @returns {*} Returns the entry value.
*/
function hashGet(key) {
	var data = this.__data__;
	if (_nativeCreate_default) {
		var result = data[key];
		return result === HASH_UNDEFINED ? void 0 : result;
	}
	return hasOwnProperty.call(data, key) ? data[key] : void 0;
}
var _hashGet_default = hashGet;

//#endregion
export { _hashGet_default as default };
//# sourceMappingURL=_hashGet.js.map